import {
  ADMIN_BASE_PATH,
  ADMIN_NAV_GROUPS,
} from "../constants/adminWorkspace";

export const isAdminPath = (pathname = "") =>
  pathname === ADMIN_BASE_PATH || pathname.startsWith(`${ADMIN_BASE_PATH}/`);

export const isAdminNavItemActive = (itemPath, pathname = "") =>
  pathname === itemPath || pathname.startsWith(`${itemPath}/`);

export const getAdminNavGroups = () =>
  ADMIN_NAV_GROUPS.map((group) => ({
    id: group.id,
    label: group.label,
    items: group.items.map((item) => ({
      ...item,
      comingSoon: false,
      isAdmin: true,
    })),
  }));
